import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { GatsbyImage } from "gatsby-plugin-image";
import { PrismicRichText } from "@prismicio/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/banks_lists.scss";
import "swiper/css";
import "swiper/css/navigation";

const BanksLists = ({ slice }) => {
  if (!slice) return null;

  return (
    <Container
      fluid
      style={{
        backgroundImage: slice.primary.background_image?.gatsbyImageData
          ? `url(${slice.primary.background_image.gatsbyImageData.images.fallback.src})`
          : null,
        backgroundSize: "cover",
      }}
      className="partners-slice"
    >
      <Container className="max-container">
        <Row>
          <Col className="text-center">
            <GatsbyImage
              image={slice.primary.logo.gatsbyImageData}
              alt={slice.primary.logo.alt || "logo"}
              className=""
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-center title mt-5 mb-2 mb-md-4">
            <PrismicRichText field={slice.primary.title.richText} />
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={10} className="text-center my-md-4">
            <PrismicRichText field={slice.primary.description.richText} />
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <div className="book-now-outline mx-auto d-none d-lg-block mona">
              <Anchor
                href={slice.primary.button_link.url}
                className="book-now-btn text-center"
                target={slice.primary.button_link.target}
              >
                {slice.primary.button_label}
              </Anchor>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={8} className="text-center my-5">
            <div className="d-inline-block highlight">
              <PrismicRichText
                field={slice.primary.highlighted_text.richText}
              />
            </div>
          </Col>
        </Row>
        {/* Desktop slider */}
        <Row>
          <Swiper
            slidesPerView={5}
            loop
            speed={100}
            autoplay
            modules={[Autoplay]}
            className="bank-swiper d-none d-md-block"
            spaceBetween={20}
          >
            {slice.items.map((item, index) => (
              <SwiperSlide key={index}>
                {item.partners.gatsbyImageData !== null && (
                  <div>
                    <GatsbyImage
                      image={item.partners.gatsbyImageData}
                      alt={item.partners.alt || "partner"}
                      className="image"
                    />
                  </div>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </Row>
        {/* Mobile slider */}
        <Row>
          <Swiper
            slidesPerView="auto"
            loop
            speed={100}
            autoplay
            modules={[Autoplay]}
            className="bank-swiper-mobile d-block d-md-none"
          >
            {slice.items.map((item, index) => (
              <SwiperSlide key={index} className="">
                {item.partners.gatsbyImageData !== null && (
                  <Col>
                    <GatsbyImage
                      image={item.partners.gatsbyImageData}
                      alt={item.partners.alt || "partner"}
                      className="image"
                    />
                  </Col>
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </Row>
      </Container>
    </Container>
  );
};

export default BanksLists;
